<div class="p-2 flex-fill d-flex flex-row">
    <div *ngIf="projections" class="m-1 grid-fill col-sm-4">
        <dx-data-grid
            #dataGrid
            [keyExpr]="'id'"
            [dataSource]="projections"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
            [showBorders]="true"
        >
            <dxi-column dataField="id" caption="Build #" width="80"></dxi-column>
            <dxi-column dataField="created" caption="Date" width="100"></dxi-column>
            <dxi-column dataField="createdBy" width="200"></dxi-column>
            <dxi-column dataField="notes"></dxi-column>

            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-secondary me-2" (click)="open()">New</button>
                <button class="btn btn-success" (click)="open(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Open
                </button>
                <button
                    class="btn btn-danger ms-2"
                    (click)="delete()"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Delete
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="buildAssemblies" class="me-3"
                    ><strong
                        >{{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong></span
                >
            </div>
        </dx-data-grid>
    </div>

    <div *ngIf="parts" class="m-1 grid-fill col-sm-8 p-1">
        <dx-data-grid
            #partsGrid
            [keyExpr]="'id'"
            [dataSource]="parts"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="partDoubleClick($event)"
            (onExporting)="onExporting($event)"
            (onRowPrepared)="onRowPrepared($event)"
            [showBorders]="true"
        >
            <dxi-column dataField="id"></dxi-column>
            <dxi-column dataField="inStock" caption="InStock" width="70"></dxi-column>
            <dxi-column dataField="allocated" caption="Allocated" width="70"></dxi-column>
            <dxi-column dataField="projectedInventory" caption="Prj.Inv." width="70"></dxi-column>
            <dxi-column dataField="_projectedQty" caption="PartsProjected" width="70" dataType="number"></dxi-column>
            <dxi-column dataField="_onOrder" caption="PartsOnOrder" width="70"></dxi-column>
            <dxi-column dataField="_onBackOrder" caption="BackOrder" width="70"></dxi-column>
            <dxi-column dataField="stockLevel" caption="Stock Level" width="70"></dxi-column>
            <dxi-column dataField="reOrderMinimum" width="70"></dxi-column>

            <dxi-column dataField="category" width="150"></dxi-column>
            <dxi-column dataField="partNumber" width="350"></dxi-column>
            <dxi-column dataField="description" width="350"></dxi-column>
            <dxi-column dataField="mfgPartNumber" width="100"></dxi-column>
            <dxi-column dataField="mfgDescription" width="100"></dxi-column>
            <dxi-column dataField="aliasHTML" caption="Aliases" width="350" [encodeHtml]="false"></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="inventory-projections-results-search-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-secondary me-2" (click)="refresh()">Refresh</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="parts" class="me-3"
                    ><strong
                        >{{ partsGrid.instance.totalCount() + ' items' }}
                        {{ partsGrid.instance.getSelectedRowsData().length > 0 ? partsGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
